import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MainService } from 'src/app/app.service';
import { SmartReviewApiService } from './smart-review-api.service';

/** Autorização de acesso ao domínio Smart Review (usado pelo guard de rota). */
@Injectable()
export class SmartReviewAccessService extends SmartReviewApiService {
  constructor(http: HttpClient, mainService: MainService) {
    super(http, mainService);
  }

  /**
   * Valida se o usuário autenticado no ESP pode acessar Smart Review/TFVC.
   * Endpoint dedicado de autorização (retorna 403/503 com códigos de negócio).
   *
   * Exceção ao X-PO-No-Message: usa headers SEM o opt-out, para que o motivo
   * (ex.: 403) seja exibido pelo toaster app-level do PO. O guard redireciona
   * para fora do módulo, onde o nosso toast (por-rota) não renderizaria.
   */
  checkReviewAccess(): Observable<void> {
    return this.http.get<void>(`${this.apiURL}/reviews`, { headers: this.toasterHeaders }).pipe(map(() => void 0));
  }

  /**
   * Valida a capability `smartreview.admin` no backend, que é a autoridade real.
   * Usa `/admin/gates` porque é resolvido antes do gate TFVC — um admin sem TFVC
   * passa. Mesma exceção ao X-PO-No-Message do checkReviewAccess: o motivo do 403
   * vem do servidor e é exibido pelo toaster app-level do PO.
   */
  checkAdminAccess(): Observable<void> {
    return this.http.get<void>(`${this.apiURL}/admin/gates`, { headers: this.toasterHeaders }).pipe(map(() => void 0));
  }

  /** Headers sem o opt-out do toaster do PO (ver comentários acima). */
  private get toasterHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: this.bearerToken, Accept: 'application/json' });
  }
}
